function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("Have a project you need to get started or a position suited for my skills? I'm currently open for both full-time offers and freelance work.")]),_vm._v(" "),_c('p',[_vm._v("My inbox is always open, let's chat! I'll do my best to respond in a timely manner.")])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"button":"Lets talk!"},
    
      body: "Have a project you need to get started or a position suited for my skills? I'm currently open for both full-time offers and freelance work.\r\n\r\nMy inbox is always open, let's chat! I'll do my best to respond in a timely manner.",
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }